export function Backet(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0001 11.5003C12.0001 10.948 11.5523 10.5003 11.0001 10.5003C10.4478 10.5003 10.0001 10.948 10.0001 11.5003V14.5003C10.0001 15.0526 10.4478 15.5003 11.0001 15.5003C11.5523 15.5003 12.0001 15.0526 12.0001 14.5003V11.5003Z"
          fill="currentColor"
        />
        <path
          d="M15.0001 10.5003C15.5523 10.5003 16.0001 10.948 16.0001 11.5003V14.5003C16.0001 15.0526 15.5523 15.5003 15.0001 15.5003C14.4478 15.5003 14.0001 15.0526 14.0001 14.5003V11.5003C14.0001 10.948 14.4478 10.5003 15.0001 10.5003Z"
          fill="currentColor"
        />
        <path
          d="M8.00005 11.5003C8.00005 10.948 7.55234 10.5003 7.00005 10.5003C6.44777 10.5003 6.00005 10.948 6.00005 11.5003V14.5003C6.00005 15.0526 6.44777 15.5003 7.00005 15.5003C7.55234 15.5003 8.00005 15.0526 8.00005 14.5003V11.5003Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.32972 0.346468C6.69248 0.164399 6.02829 0.533389 5.84622 1.17063L4.3806 6.3003H3.39648C3.2045 6.3003 3.01292 6.31757 2.82404 6.35191C1.08524 6.66806 -0.0680523 8.33393 0.248094 10.0727L1.52082 17.0727C1.79747 18.5943 3.12269 19.7003 4.6692 19.7003H17.3309C18.8774 19.7003 20.2026 18.5943 20.4793 17.0727L21.752 10.0727C21.7864 9.88385 21.8036 9.69227 21.8036 9.5003C21.8036 7.73299 20.3709 6.3003 18.6036 6.3003H17.6195L16.1539 1.17063C15.9718 0.533389 15.3076 0.164399 14.6704 0.346468C14.0331 0.528537 13.6642 1.19272 13.8462 1.82996L15.1235 6.3003H6.87664L8.15388 1.82996C8.33595 1.19272 7.96696 0.528537 7.32972 0.346468ZM19.4036 9.5003C19.4036 9.05847 19.0455 8.7003 18.6036 8.7003H3.39648C3.34848 8.7003 3.30059 8.70462 3.25337 8.7132C2.81867 8.79224 2.53035 9.2087 2.60938 9.6434L3.88211 16.6434C3.95127 17.0238 4.28258 17.3003 4.6692 17.3003H17.3309C17.7175 17.3003 18.0488 17.0238 18.118 16.6434L19.3907 9.6434C19.3993 9.59619 19.4036 9.54829 19.4036 9.5003Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
